<script>
import _ from 'lodash';
import { STATE_TYPE, INPUT_TYPE } from '../config/constant'
import { getConfigOptionsListApi } from '@/api'
export default {
    props: [ 'list','cbs' ],//constant
    name: 'AddSqlDataModal',
    data() {
        return {
            formData: {},
            changeEvent: {},
            fieldOption: {},
            loading: false
        }
    },
    render(h) {
        const _this = this;
        const nodes = [];
        const formItemNodes = this.list.filter(v=>v.add_disable === STATE_TYPE.ENABLE).map(col=> {
            const rules = [];
            if (col.add_required === STATE_TYPE.DISABLE) {
                rules.push({
                    required: true, message: '此项必填', trigger:'blur'
                })
            };
            if (col.validate_frontend) {
                rules.push({ 
                    validator: (rule, value, callback)=> {
                        if (!value) {
                            callback();
                            return;
                        };
                        const test = new RegExp(col.validate_frontend);
                        if (!test.test(value)) {
                           callback(new Error(col.validate_msg)); 
                        }else {
                            callback()
                        }
                    },
                    trigger: 'blur' 
                })
            }
            return h('ElFormItem', {
                props: {
                    label: col.show_name,
                    prop: col.field_name,
                    rules
                },
                scopedSlots: {
                    default:()=> _this.genInputNode(h, col)
                }
            })
        })
        nodes.push(h('ElForm', {
            props: {
                'label-width': '120px',
                model: _this.formData
            },
            scopedSlots: {
                default: ()=>formItemNodes,
            },
            ref:'sqlFormRef'
        }));
        const btnNodes = [
            h("ElButton", {props: { type: 'primary', loading: _this.loading}, on: { click: ()=>_this.handleSaveDataClick() }}, '保存'),
            h("ElButton", {props: { disabled: _this.loading } ,on: { click: ()=> _this.$emit('close')}}, '取消')
        ];
        nodes.push(h('div', { class:'btns' }, btnNodes))    
        // nodes.push('div', null,JSON.stringify( _this.formData)) 
        return h('div', nodes)
    },
    computed: {
        fieldIdName() {
            return this.list.reduce((pre, item)=> {
                pre[item.id] = item.field_name;
                return pre;
            }, {})
        }
    },
    methods: {
        handleSaveDataClick() {
            this.$refs.sqlFormRef.validate((valid)=> {
                if (valid) {
                    this.$confirm('请谨慎新增数据，是否保存?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.loading = true;
                        this.cbs.onSubmit({
                            ...this.formData
                        }, ()=> {
                            this.loading = false
                        })
                    }).catch(() => {});
                }
            })
        },
        genInputNode(h, column) {
            const _this = this;
            if (column.required) {
                const fieldIds = column.required.split(',');
                fieldIds.forEach(id=> {
                    const events = this.changeEvent[this.fieldIdName[id]];
                    const fn = ()=> {
                        if (_this.formData[column.field_name]) {
                            _this.formData[column.field_name] = null;
                        }
                    };
                    if (events) {
                        events[column.field_name] = fn
                    }else {
                        this.changeEvent[this.fieldIdName[id]] = { 
                            [column.field_name]: fn
                        }
                    }
                });
            }
            
            const attrs = {
                props: {
                    value: this.formData[column.field_name]
                },
                on: {
                    input: (value)=> {
                        this.formData = {
                            ...this.formData,
                            [column.field_name]: value
                        }
                    },
                    change: ()=> {
                        const data = this.changeEvent[column.field_name];
                        if (data) {
                            // 改变后清空相关联的数据
                            Object.values(data).map(v=> v())
                        }
                    }
                },
            }
            switch (column.type) {
                case 'select':
                    const options =  this.fieldOption[column.field_name] || [];
                    const nodes =options.map(option=> {
                        return h('ElOption', {
                            props: {
                                value: option.id,
                                label: option.name
                            }
                        })
                    });
                    return h('ElSelect', _.merge(attrs, {
                        props: {
                            placeholder: '请输入'
                        },
                        on: {
                            focus: async ()=> {
                                _this.getConfigOptionsList(column)
                            }
                        },
                        scopedSlots: {
                            default:()=> {
                                return nodes;
                            }
                        }
                    }))
                case 'text':
                    return h('ElInput', _.merge(attrs, {}))
                default:
                    break;
            };
        },
        async getConfigOptionsList(column) {
            try {
                const { id, table_id,field_name ,required } = column;
                // {
                //     required:'plat_id,plat_name'
                // }
                const params = {
                    table_id,
                    field_id: id,
                };
                const row = this.formData;
                if (required) {
                    const fieldIdName = this.fieldIdName;
                    const param = required.split(',').reduce((pre,id)=> {
                        const key = fieldIdName[id];
                        pre[key] = row[key]
                        return pre;
                    }, {});
                    Object.assign(params, param);
                };
                this.$set(this.fieldOption, column.field_name, [])
                const {data} = await getConfigOptionsListApi(params);
                this.$set(this.fieldOption, column.field_name, data)
            } catch (error) {
                this.$message.error(error.info || error.message)
            } 
        }
    }
}
</script>

<style lang="scss" scoped>
.btns {
    padding-top: 16px;
    text-align: center;
}
</style>